import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-remove",
  templateUrl: "./med-icon-remove.component.html",
})
export class MedIconRemoveComponent extends SvgMixinComponent {}
